import { DefaultProjectorFn, MemoizedSelector, createFeature, createSelector } from '@ngrx/store';

import { DoodCartModel, NO_PREPAYMENT_COUPON } from '@core/models/cart.model';

import { CART_STORE_REDUCER } from './cart.reducer';
import { CART_STORE_ACTIVE_ADAPTER, CART_STORE_KEY, CartState } from './cart.state';
import { SELECT_PREPAYMENT_TOP_UP_PRODUCT_ID } from '@store/prepayment/prepayment.selection';

const CART_STORE_FEATURE = createFeature({
  name: CART_STORE_KEY,
  reducer: CART_STORE_REDUCER,
});

export const {
  selectComment: SELECT_CART_COMMENT,
  selectCartState: SELECT_CART_STATE,
  selectActive: SELECT_CART_ACTIVE_ID,
  selectEntities: SELECT_CART_ENTITIES,
  selectEdit_item: SELECT_CART_EDIT_ITEM,
  selectLast_update: SELECT_CART_LAST_UPDATE,
} = CART_STORE_FEATURE;

export const { selectAll: SELECT_CART_ALL, selectTotal: SELECT_CART_TOTAL } =
  CART_STORE_ACTIVE_ADAPTER.getSelectors(SELECT_CART_STATE);

export const SELECT_CART_ENTITY = (
  id: string,
): MemoizedSelector<
  Record<string, any>,
  DoodCartModel | undefined,
  DefaultProjectorFn<DoodCartModel | undefined>
> =>
  createSelector(SELECT_CART_STATE, (state: CartState) => {
    return state.entities[id];
  });

export const SELECT_CART_ACTIVE = createSelector(
  SELECT_CART_ENTITIES,
  SELECT_CART_ACTIVE_ID,
  (entities, id) => (id ? (entities[id] ?? null) : null),
);

export const SELECT_CART_ACTIVE_TYPE = createSelector(
  SELECT_CART_ENTITIES,
  SELECT_CART_ACTIVE_ID,
  (entities, id) => (id ? (entities[id]?.type ?? null) : null),
);

export const SELECT_CART_PREPAYMENT_ENABLE = createSelector(
  SELECT_CART_ACTIVE,
  cart => !cart?.coupons?.some(coupon => coupon.type === NO_PREPAYMENT_COUPON.type),
);

export const SELECT_CART_TOP_UP_PRODUCT_ITEM = createSelector(
  SELECT_CART_ACTIVE,
  SELECT_PREPAYMENT_TOP_UP_PRODUCT_ID,
  (cart, topUpProductId) => {
    const r = cart?.products.find(cartItem => cartItem.item_id === topUpProductId) || null;
    return r;
  },
);

export const SELECT_CART_LAST_2_SELECTED_PRODUCT_ORIGIN = createSelector(
  SELECT_CART_STATE,
  state => state.last2SelectedProductOrigin,
);

export const SELECT_CART_LAST_EDITED_CART_ITEM = createSelector(
  SELECT_CART_STATE,
  state => state.lastEditedCartItem,
);
